// extracted by mini-css-extract-plugin
export default {"block":"main_block__V98LG","title":"main_title__quGWG","box":"main_box__TB22L"};